/* unplugin-vue-components disabled */import { render } from "./establishment.vue?vue&type=template&id=70a93781&scoped=true"
import script from "./establishment.vue?vue&type=script&lang=js"
export * from "./establishment.vue?vue&type=script&lang=js"

import "./establishment.vue?vue&type=style&index=0&id=70a93781&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a93781"],['__file',"src/components/cards/persona/education/establishment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70a93781"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70a93781', __exports__)) {
    api.reload('70a93781', __exports__)
  }
  
  module.hot.accept("./establishment.vue?vue&type=template&id=70a93781&scoped=true", () => {
    api.rerender('70a93781', render)
  })

}


export default __exports__